import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// component modules
import { CoreNotificationsMainComponent } from './main/main.component';
import { CoreNotificationsHelpersModule } from './helpers/notifications-helpers.module';

// components

@NgModule({
    imports: [
        CommonModule,
        CoreNotificationsHelpersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        CoreNotificationsMainComponent
    ],
    exports: [
        CoreNotificationsMainComponent
    ],

})
export class CoreNotificationsModule { }
// Module for notifications components
